import { Box, Text } from '@vouched.id/vault';
import React from 'react';
import { WarningIcon } from './Icons/Warning';
import { StatusColors } from './utils';
const getStatusColor = (status) => {
    switch (status) {
        case 'active':
            return '#0000CC';
        case 'removed':
            return '#222222';
        case 'approved':
            return '#00CC00';
        case 'rejected':
            return '#CC0000';
        case 'warning':
            return StatusColors.Warning;
    }
};
export const JobStatusLabel = ({ status, hasWarnings }) => {
    return (React.createElement(Box, { display: "flex", style: {
            justifyContent: 'center',
            alignItems: 'center'
        } },
        React.createElement(Box, { display: "flex", style: {
                backgroundColor: status === 'completed' ? '#FFFFFF' : getStatusColor(status),
                height: '30px',
                borderRadius: '30px',
                padding: '0px 20px',
                justifyContent: 'center',
                alignItems: 'center',
                textTransform: 'capitalize'
            } },
            React.createElement(Text, { colorVariation: status === 'completed' || status === 'warning'
                    ? 'primary'
                    : 'inversePrimary' }, status === 'completed' ? 'Completed' : status)),
        hasWarnings && status === 'approved' && React.createElement(WarningIcon, { size: 30 })));
};
